import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex h-full items-center justify-center text-sm"
}

import { ComputedRef, computed } from 'vue';
import { useFavoritesStore } from '@/stores/favorites';
import { TranslateKey, useInject } from '@/composables/use-inject';
import ItemFavoritesItem from '@/components/ItemFavorites/ItemFavoritesItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemFavoritesList',
  emits: {
  effect: null,
},
  setup(__props, { emit }) {



const translate = useInject(TranslateKey);
const favoritesStore = useFavoritesStore();

const favoritesList: ComputedRef<string[]> = computed((): string[] => {
  return favoritesStore.getFavorites;
});

const itemFavoritesItemEffect = (): void => {
  emit('effect');
};

return (_ctx: any,_cache: any) => {
  return (_unref(favoritesList).length)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(favoritesList), (searchWord, index) => {
        return (_openBlock(), _createBlock(ItemFavoritesItem, {
          key: searchWord,
          index: ++index,
          "search-word": searchWord,
          onEffect: itemFavoritesItemEffect
        }, null, 8, ["index", "search-word"]))
      }), 128))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(translate)('itemFavorites.emptyFavorites')), 1))
}
}

})